<div class="container" style="height: 85vh">
  <div class="row">

    <div class="col-6">
      <div class="logo">
        <img style="width: 514px" src="../../../assets/img/Logo_ATENEA.png" alt="Atenea logo">
      </div>
    </div>

    <div class="col-5">
      <div class="login">

        <div class="rect front">
          <div class="custom-row first">
            <h4 style="color: white;">{{this.localiser.get("login.email")}}</h4>
            <input [(ngModel)]="email" (keyup.enter)="logIn()" type="email" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" />
          </div>
          <div class="custom-row">
            <h4 style="color: white;">{{this.localiser.get("login.password")}}</h4>
            <input [(ngModel)]="password" (keyup.enter)="logIn()" type="password" class="form-control" id="exampleInputPassword1">
          </div>
          <div class="custom-row">
            <button type="submit" (click)="logIn()" class="custom-btn btn">{{this.localiser.get("login.buttonLogin")}}</button>
          </div>

          <div *ngIf="feedbackLogin < 0" class="col errorMessage">
            {{whichMessage()}}
          </div>

          <div *ngIf="feedbackLogin > 0" class="col doneMessage">
            {{whichMessage()}}
          </div>

          <div *ngIf="chargingLogin" class="col">
            <mat-progress-spinner class="spinner" color="primary" mode="indeterminate" diameter="40">
            </mat-progress-spinner>
          </div>

        </div>

        <!-- CUADROS DE COLORES DEL LOGIN
        <div class="rect back red"></div>
        <div class="rect back yellow"></div>
        -->

      </div>
    </div>

  </div>
</div>

<img class="heartLogin" src="../../../assets/img/login/heart.svg" alt="Atenea heart">

<footer class="page-footer foot">
  <div class="footerButtons">
    <div class="contact">
      <span class="material-icons-outlined contactIcon">support_agent</span>
    </div>

    <mat-select class="language" (ngModelChange)="changeLanguage($event)" [(ngModel)]="this.localiser.languageName">
      <mat-option value="Español">Español</mat-option>
      <mat-option value="English">English</mat-option>
    </mat-select>

  </div>
</footer>


